import React from "react";
import { useTranslation } from "react-i18next";
import { BaseControlQuestionProps } from "./type";
import { Question } from "../question";
import { SliderQuestion as SliderType } from "@shared/types";
import { ControlledSlider } from "../form/controlled-slider";

const marks = [
  {
    value: 0,
    label: "0",
  },
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
  {
    value: 4,
    label: "4",
  },
  {
    value: 5,
    label: "5",
  },
  {
    value: 6,
    label: "6",
  },
  {
    value: 7,
    label: "7",
  },
  {
    value: 8,
    label: "8",
  },
  {
    value: 9,
    label: "9",
  },
  {
    value: 10,
    label: "10",
  },
];

export const SliderQuestion: React.FC<
  Omit<BaseControlQuestionProps, "required"> &
    Omit<SliderType, "type" | "required">
> = ({ id, control, question, options, position }) => {
  const { i18n, t } = useTranslation();

  return (
    <Question
      id={id}
      question={<span>{question[i18n.language]}</span>}
      direction="column"
      position={position}
    >
      <ControlledSlider
        name={id}
        control={control}
        // Note: Hard coded. Must be adjusted as soon as other slider are introduced
        minLabel={t("components.slider.no_pain")}
        maxLabel={t("components.slider.max_pain")}
        marks={marks}
        min={options.min}
        max={options.max}
        step={options.step}
      />
    </Question>
  );
};
